<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition">
    <!--v-dialog had these props: fullscreen hide-overlay. testing without -->
    <template v-slot:activator="{ on }">
      <v-tooltip v-on="on" top>
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab color="secondary" v-on="on" @click="dialog=true">
            <v-icon dark>mdi-dice-multiple</v-icon>
          </v-btn>
        </template>
        <span>Random NPC</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Random NPC</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="AddNPC()">Generate</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form ref="NewNPC" class="pa-4">
        <v-row>
          <v-col col="12" md="4">
            <v-select
              v-model="race"
              :items="NPC.Races"
              label="Race"
              item-text="name"
              item-value="id"
              dense
              outlined
              @change="UpdateSubRace($event)"
            ></v-select>
          </v-col>
          <v-col col="12" md="4" v-if="NPC.Subraces.length>1">
            <v-select
              v-model="subrace"
              :items="NPC.Subraces"
              label="SubRace"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col col="12" md="4">
            <v-select
              v-model="gender"
              :items="NPC.Genders"
              label="Gender"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col col="12" md="4">
            <v-select
              v-model="classorprof"
              :items="NPC.classorprof"
              label="Occupation"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  getNamedTableOptions,
  // getTableReferenceOptions,
} from "../npcData/tables";
import { generate } from "../npcData/generate";
import { store } from "@/fb";
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  props: ["TempTown"],
  data: () => ({
    race: null,
    gender: null,
    classorprof: null,
    subrace: null,
    NPC: {
      Races: [],
      Genders: [],
      Subraces: [],
      classorprof: [
        { name: "Class", id: 0 },
        { name: "Profession", id: 1 },
        { name: "Random", id: null },
      ],
    },
    NewNpc: {},
    dialog: false,
  }),
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
    let random = { name: "Random", id: null };
    this.NPC.Genders = [...getNamedTableOptions("gender")];
    this.NPC.Genders.forEach((o, i) => (o.id = i));

    if (this.NPC.Genders.indexOf(random) === -1) {
      this.NPC.Genders.push(random);
    }
    this.gender = random.id;
    this.NPC.Races = [...getNamedTableOptions("race")];
    this.NPC.Races.forEach((o, i) => (o.id = i));
    this.NPC.Races.push(random);
    this.race = random.id;
  },
  methods: {
    AddNPC() {
      const options = {
        race: this.race,
        subrace: this.subrace,
        classorprof: this.classorprof,
        gender: this.gender,
      };
      const npc = generate(options).npc;
      const majP = npc.description.pronounCapit;
      // useful if I want to split quirks into spearte lines for now I think it is fine
      //   const quirksArray = npc.pquirks.description.split(".");

      this.NewNpc = {
        Name: npc.description.name,
        Age: npc.description.age,
        Race: npc.description.race,
        Description: `${majP}has ${npc.physical.hair}${npc.physical.eyes}.  ${majP}has ${npc.physical.skin}.
        ${majP}stands ${npc.physical.height}cm tall and has ${npc.physical.build}.  ${majP}has ${npc.physical.face}.
        ${npc.physical.special1}
        ${npc.physical.special2}`,
        Abilities: npc.abilities,
        Alignment: npc.alignment,
        Occupation: npc.description.occupation,
        Notes: `${majP} is ${npc.relationship.orientation} and is ${npc.relationship.status}. 
        ${npc.religion.description}. 
        ${npc.ptraits.traits1}
        ${npc.ptraits.traits2}
        ${npc.pquirks.description}`,
        hook: npc.hook.description,
        CampaignId: store.CurrentCampaign.id,
        CreateDate: firebase.firestore.FieldValue.serverTimestamp(),
        UpdateDate: firebase.firestore.FieldValue.serverTimestamp(),
        PlayerId: this.playerid,
        Town: {},
        Inventory: [],
      };
      if (this.TempTown != null) {
        this.NewNpc.Town.id = this.TempTown.id;
        this.NewNpc.Town.Name = this.TempTown.Name;
      }
      db.collection("npcs")
        .add(this.NewNpc)
        .then((docRef) => {
          this.$router.push({ name: "NPC", params: { id: docRef.id } });
        });
    },
    UpdateSubRace(event) {
      let random = { name: "Random", id: null };
      let racename = this.NPC.Races[event].name;
      switch (racename) {
        case "Elf":
          this.NPC.Subraces = [...getNamedTableOptions("raceelf")];
          break;
        case "Dwarf":
          this.NPC.Subraces = [...getNamedTableOptions("racedwarf")];
          break;
        case "Gnome":
          this.NPC.Subraces = [...getNamedTableOptions("racegnome")];
          break;
        case "Halfling":
          this.NPC.Subraces = [...getNamedTableOptions("racehalfling")];
          break;
        default:
          this.NPC.Subraces = [];
      }
      this.NPC.Subraces.forEach((o, i) => (o.id = i));
      this.NPC.Subraces.push(random);
    },
  },
};
</script>
